import { Component } from '@angular/core';
import { AnalyticsService } from './core/services/analytics.service';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {
  // Start GA4 SPA tracking once, before the router's initial NavigationEnd fires.
  constructor(analytics: AnalyticsService) {
    analytics.init();
  }
}
